var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { Box, get, TextBody } from '@ally/metronome-ui';
import { formattedDate, isAfterDeliverOnDate } from '../utils';
import SummaryTrackerMarker from './SummaryTrackerMarker';
import { trackerStatuses, trackerSteps } from '../../constants';
function getStatusContent(_a) {
    var activityName = _a.activityName, currentStatus = _a.currentStatus;
    switch (currentStatus) {
        case 'Confirmed':
            return 'Ordered';
        case 'InProcess':
            return activityName === 'ACHTransfer' ? 'Processing' : 'Ordered';
        case 'Completed':
        case 'Posted':
            return 'Delivered';
        default:
            return currentStatus;
    }
}
var TrackerStep = styled.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  flex: 1;\n  &:first-child {\n    ", " {\n      text-align: left;\n    }\n  }\n\n  &:first-child,\n  &:last-child {\n    white-space: nowrap;\n    min-width: 70px;\n    ", " {\n      min-width: initial;\n    }\n  }\n\n  &:last-child {\n    > div::after {\n      display: none;\n    }\n    max-width: 70px;\n    ", " {\n      text-align: right;\n      max-width: initial;\n    }\n  }\n"], ["\n  margin: 0;\n  padding: 0;\n  flex: 1;\n  &:first-child {\n    ", " {\n      text-align: left;\n    }\n  }\n\n  &:first-child,\n  &:last-child {\n    white-space: nowrap;\n    min-width: 70px;\n    ", " {\n      min-width: initial;\n    }\n  }\n\n  &:last-child {\n    > div::after {\n      display: none;\n    }\n    max-width: 70px;\n    ", " {\n      text-align: right;\n      max-width: initial;\n    }\n  }\n"])), get.media.down('md'), get.media.down('md'), get.media.down('md'));
function currentStepStatus(_a) {
    var statuses = _a.statuses, step = _a.step;
    return statuses.find(function (history) {
        if (step === 'Ordered') {
            return trackerStatuses.ordered.includes(history.status);
        }
        return history.status === step;
    });
}
var StepContent = function (_a) {
    var event = _a.event, currentStatus = _a.currentStatus, markerType = _a.markerType, showAchDelivered = _a.showAchDelivered, step = _a.step;
    var hasLabel = markerType !== 'default';
    var deliverOnDate = event.eventModelData.deliverOnDate;
    var isAch = event.activityName === 'ACHTransfer';
    var showDeliverOnDate = isAch && step === 'Completed';
    return hasLabel ? (React.createElement(Box, { mt: "xxs", width: markerType === 'start' ? '70px' : 'auto' },
        React.createElement(TextBody, { tag: "div", size: "sm" },
            showDeliverOnDate && !currentStatus && (React.createElement(React.Fragment, null,
                React.createElement(TextBody, { tag: "p", size: "xs", weight: "bold" }, showAchDelivered ? 'Delivered' : 'Deliver On'),
                React.createElement(TextBody, { tag: "p", size: "sm" }, formattedDate(deliverOnDate, 'MMM D')))),
            currentStatus && (React.createElement(React.Fragment, null,
                React.createElement(TextBody, { tag: "p", size: "xs", weight: "bold" }, getStatusContent({
                    activityName: event.activityName,
                    currentStatus: currentStatus.status,
                })),
                React.createElement(TextBody, { tag: "p", size: "sm" }, formattedDate(showDeliverOnDate ? deliverOnDate : currentStatus.eventDateTime, 'MMM D'))))))) : null;
};
function getMarkerType(_a) {
    var _b;
    var event = _a.event, step = _a.step, showAchDelivered = _a.showAchDelivered;
    var useAchDelivered = ((_b = event.statuses[0]) === null || _b === void 0 ? void 0 : _b.status) === 'InProcess' && showAchDelivered;
    var steps = trackerSteps[event.activityName];
    if (steps[0] === step) {
        return 'start';
    }
    if (steps[steps.length - 1] === step ||
        step === 'Canceled' ||
        useAchDelivered) {
        return 'end';
    }
    return 'default';
}
var SummaryTrackerStep = function (_a) {
    var event = _a.event, isCanceled = _a.isCanceled, status = _a.status, step = _a.step;
    var eventModelData = event.eventModelData, statuses = event.statuses;
    var deliverOnDate = eventModelData.deliverOnDate;
    var showAchDelivered = isAfterDeliverOnDate(deliverOnDate);
    var markerType = getMarkerType({ event: event, step: step, showAchDelivered: showAchDelivered });
    var currentStatus = currentStepStatus({ statuses: statuses, step: step });
    var isFirstStep = statuses.length === 1;
    return (React.createElement(TrackerStep, null,
        !isCanceled && (React.createElement(SummaryTrackerMarker, { markerType: markerType, status: showAchDelivered ? 'Success' : status, hasHistory: !!currentStatus, isFirstStep: isFirstStep })),
        React.createElement(StepContent, { event: event, currentStatus: currentStatus, markerType: markerType, showAchDelivered: showAchDelivered, step: step })));
};
export default SummaryTrackerStep;
var templateObject_1;
//# sourceMappingURL=SummaryTrackerStep.js.map